module.exports = __webpack_public_path__ + "img/logo.f334c21d.png";